"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var insert_widget_button_html_1 = __importDefault(require("./insert-widget-button.html"));
require("./insert-widget-button.less");
(function (module) {
    'use strict';
    function InsertWidgetButtonController(widgetInit, insertMenuService, prFlowingPages, prMetricsService) {
        var $ctrl = this;
        angular.extend($ctrl, {
            widgetCountExceedLimitTooltip: insertMenuService.getWidgetCountExceedLimitTooltip(),
            getInsertItems: function () {
                var disablePageBreak = false;
                if ($ctrl.bdyCtrl.activePage === 0) {
                    var pages = prFlowingPages.getPages();
                    var activePageWidgets = pages[$ctrl.bdyCtrl.activePage].widgets;
                    if (!activePageWidgets.length) {
                        disablePageBreak = true;
                    }
                    else if (activePageWidgets[0]._id === $ctrl.bdyCtrl.activeWidgetId && $ctrl.type === 'top') {
                        // disable pagebreak only for the top insert menu,
                        // so that we dont add a pb at the top of the first page
                        disablePageBreak = true;
                    }
                }
                return insertMenuService.getMenuItems(false, disablePageBreak);
            },
            insertItem: function (value) {
                if (!$ctrl.bdyCtrl.activeWidgetId) {
                    $ctrl.bdyCtrl.setActivePage($ctrl.pageNumber);
                }
                var config;
                if (value.fieldId) { // survey data
                    config = widgetInit.getWidgetConfigFromField(value);
                    widgetInit.setWidgetInitConfig(config);
                    $ctrl.bdyCtrl.addWidgetToActivePage(config.type, $ctrl.type === 'top', config.sourceId, config.fieldId);
                }
                else { // add widget
                    $ctrl.bdyCtrl.addWidgetToActivePage(value, $ctrl.type === 'top');
                }
                prMetricsService.visualizationAdd(config, value, prMetricsService.CALL_SOURCE.BUTTON);
            },
            shouldDisableInsert: function () {
                return prFlowingPages.hasReachedWidgetLimit();
            }
        });
    }
    InsertWidgetButtonController.$inject = [
        'prWidgetInit',
        'prInsertMenuService',
        'prFlowingPages',
        'prMetricsService'
    ];
    module.component('prInsertWidgetButton', {
        templateUrl: insert_widget_button_html_1.default,
        controller: InsertWidgetButtonController,
        bindings: {
            widget: '<',
            type: '<',
            pageNumber: '<'
        },
        require: {
            bdyCtrl: '^^prBody'
        }
    });
})(angular.module('qualtrics.pr'));
